export default __webpack_public_path__ + "static/media/mitsubishi.f19a4f52.svg";